import { createApp } from "vue";
import App from "./App.vue";
import "./registerServiceWorker";

// @ts-ignore
createApp(App).mount("#app");
